import './App.css';
import './sumthin'
import React, {useEffect, useRef, useState} from 'react';

import Sumthins from "./sumthin";
import Add from "./Add";
import EditModal from "./EditModal";
import Header from "./Header";
import Sort from "./Sort"

function App() {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [state, set_state] = useState('default');
    const [clist, set_clist] = useState([]);
    const [csug, set_csug] = useState([]);
    const [mlist, set_mlist] = useState([]);
    const [msug, set_msug] = useState([]);
    const [cvis, set_cvis] = useState(true);
    const [mvis, set_mvis] = useState(true);
    const [sort, set_sort] = useState( 'count');
    const [cdata, set_data]= useState( {});
    const [editItem, set_editItem] = useState(null);
    const [searching, set_searching] = useState(false);
    const [search, set_search] = useState('');
    const searchRef = useRef(null);

    const AddLogo = process.env.PUBLIC_URL + "/add_circle_white_48dp.svg";
    const SearchIcon = process.env.PUBLIC_URL + "/search_24dp_E3E3E3.svg";
    const AppLogo = process.env.PUBLIC_URL + "/sumthinsumthin2.png";

    const mlistC = function (sumthin) {
        //console.log("mlistC " + sumthin);
        gotSumthin(sumthin, 'meijer');
    }

    const msugC = function (sumthin) {
        //console.log("msugC " + sumthin);
        addSumthin(sumthin, 'meijer');
    }

    const clistC = function (sumthin) {
        //console.log("clistC " + sumthin);
        gotSumthin(sumthin, 'costco');
    }

    const csugC = function (sumthin) {
        //console.log("csugC " + sumthin);
        addSumthin(sumthin, 'costco');
    }

    const clistLP = function (sumthin) {
        set_editItem({ name: sumthin, venue: 'costco', type: 'item' });
        set_state('edit');
    }

    const mlistLP = function (sumthin) {
        set_editItem({ name: sumthin, venue: 'meijer', type: 'item' });
        set_state('edit');
    }

    const csugLP = function (sumthin) {
        set_editItem({ name: sumthin, venue: 'costco', type: 'suggestion' });
        set_state('edit');
    }

    const msugLP = function (sumthin) {
        set_editItem({ name: sumthin, venue: 'meijer', type: 'suggestion' });
        set_state('edit');
    }

    const setData = function (json, csort = null) {
        if( json != null ) {
            set_data(json);
            //console.log("Setting data");
        }
        else
            json = cdata;

        if( csort == null)
            csort = sort;
        let citems = json.items.filter(s => s['venue'] === 'costco');
        let cinames = citems.map(f => f.name);
        let csug = json.suggestions.filter(s => s['venue'] === 'costco').filter(t => !cinames.includes(t['name']));

        let mitems = json.items.filter(s => s['venue'] === 'meijer');
        let minames = mitems.map(f => f.name);
        let msug = json.suggestions.filter(s => s['venue'] === 'meijer').filter(t => !minames.includes(t['name']));

        //console.log("Sorting by " + sort);
        if( csort !== 'default'){
            if( csort !== 'name') {
                msug = ssort(msug, csort, true);
                csug = ssort(csug, csort, true);
            }else{
                msug = ssort(msug, csort, false);
                csug = ssort(csug, csort, false);
            }
        }

        set_csug(csug.map(f => f.name));
        set_clist(cinames);

        set_msug(msug.map(f => f.name));
        set_mlist(minames);
    }

    const ssort = function (vals, fname, reverse){
        const cmp = fname === 'name'
            ? (a, b) => a[fname].localeCompare(b[fname], undefined, {sensitivity: 'base'})
            : (a, b) => a[fname] - b[fname];
        if( reverse ){
            return vals.sort((a, b) => cmp(b, a));
        }
        return vals.sort((a, b) => cmp(a, b));
    }

    const setError = function (error) {
        console.log(error);
    }

    const fetchData = async (script = 'sumthin.php', params = null, why = null) => {
        if( why )
            console.log("fetchin " + why);
        try {
            let path = BASE_URL + script;
            if (params) {
                path += "?" + params;
            }

            const response = await fetch(path);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            //          console.log("fetched sumthin");
            setData(jsonData);
        } catch (err) {
            setError(err);
        } finally {
            //set loading to false
        }
    };

    const addSumthin = async (name, venue) => {
        let params = "name=" + encodeURIComponent(name) +
            "&venue=" + encodeURIComponent(venue);
        //console.log("addin sumthin");
        fetchData("add.php", params, "addin")
    };

    const gotSumthin = async (name, venue) => {
        //    console.log("got sumthin");
        let params = "name=" + encodeURIComponent(name) +
            "&venue=" + encodeURIComponent(venue);
        fetchData('gotit.php', params, "gotit")
    };

    const onAdd = function (name, venue) {
        set_state('default');
        //console.log("Add! " + name + " " + venue);
        if (name && venue) {
            addSumthin(name, venue);
        }
    }

    const onEdit = function (origName, origVenue, newName, newVenue) {
        set_state('default');
        set_editItem(null);
        let params = "name=" + encodeURIComponent(origName) +
            "&venue=" + encodeURIComponent(origVenue) +
            "&newName=" + encodeURIComponent(newName) +
            "&newVenue=" + encodeURIComponent(newVenue);
        fetchData('edit.php', params, "editing");
    }

    const onDelete = function (name, venue) {
        set_state('default');
        set_editItem(null);
        let params = "name=" + encodeURIComponent(name) +
            "&venue=" + encodeURIComponent(venue);
        fetchData('delete.php', params, "deleting");
    }

    const onEditDismiss = function () {
        set_state('default');
        set_editItem(null);
    }

    function showAdd() {
        set_state('add');
    }

    const onSort = function (name) {
        console.log("Sort " + name);
        set_sort(name);
        setData(null, name);
    }

    const toggleHeader = function(name) {
        if (name === 'Meijer')
            set_mvis(!mvis);
        if (name === 'Costco')
            set_cvis(!cvis);
    }

    const filtered = (arr) => search ? arr.filter(name => name.toLowerCase().includes(search.toLowerCase())) : arr;

    const exitSearch = () => {
        set_searching(false);
        set_search('');
    };

    const handleAppClick = (e) => {
        if (searching && searchRef.current && !searchRef.current.contains(e.target)) {
            exitSearch();
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!searching) return;
        const handleEsc = (e) => {
            if (e.key === 'Escape') exitSearch();
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [searching]);

    if (state === "edit" && editItem)
        return (
            <div className="App">
                <EditModal item={editItem} onSave={onEdit} onDelete={onDelete} onCancel={onEditDismiss}/>
            </div>
        );

    if (state === "add")
        return (
            <div className="App">
                <Add onAdd={onAdd}/>
            </div>
        );

    if (state === "default")
        return (
            <div className="App" onClick={handleAppClick}>
                <div className='appSearch'>
                    <img src={SearchIcon} alt='search' onClick={() => set_searching(true)}/>
                </div>
                <div className='appSort'><Sort name={sort} onSort={onSort}/></div>
                {searching ? (
                    <h3>
                        <input
                            ref={searchRef}
                            type="text"
                            value={search}
                            onChange={(e) => set_search(e.target.value)}
                            autoFocus
                            placeholder="Search..."
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #61dafb',
                                color: 'white',
                                fontSize: 'inherit',
                                outline: 'none',
                                width: '60%',
                                textAlign: 'center',
                            }}
                        />
                    </h3>
                ) : (
                    <h3>
                        <img src={AppLogo} alt="Sumthin" style={{height: '1.5em'}} />umthin
                    </h3>
                )}
                <header className="App-header">
                    <Header name="Costco" onClick={toggleHeader} visible={cvis}/>
                    <Header name="Meijer" onClick={toggleHeader} visible={mvis}/>
                </header>
                <header className="App-body">

                    <Sumthins name="Costco" sumthins={filtered(clist)} suggested={filtered(csug)} liClick={clistC} sClick={csugC}
                              liLongPress={clistLP} sLongPress={csugLP} hidden={!cvis}/>
                    <Sumthins name="Meijer" sumthins={filtered(mlist)} suggested={filtered(msug)} liClick={mlistC} sClick={msugC}
                              liLongPress={mlistLP} sLongPress={msugLP} hidden={!mvis}/>
                    <div className='fab' onClick={showAdd}>
                        <img style={{width: '100%', height: '100%'}} src={AddLogo} alt='add'/>
                    </div>
                </header>
            </div>
        );

}

export default App;
